// extracted by mini-css-extract-plugin
export default {"previewWorkspaceTitle":"PreviewWorkspace_previewWorkspaceTitle__0Iv59"};